import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FormFixedResponse } from './form-fixed-response.model';
import * as FormFixedResponseActions from './form-fixed-response.actions';

export const formFixedResponsesFeatureKey = 'formFixedResponses';

export interface State extends EntityState<FormFixedResponse> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FormFixedResponse> = createEntityAdapter<FormFixedResponse>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FormFixedResponseActions.addFormFixedResponse,
    (state, action) => adapter.addOne(action.formFixedResponse, state)
  ),
  on(FormFixedResponseActions.upsertFormFixedResponse,
    (state, action) => adapter.upsertOne(action.formFixedResponse, state)
  ),
  on(FormFixedResponseActions.addFormFixedResponses,
    (state, action) => adapter.addMany(action.formFixedResponses, state)
  ),
  on(FormFixedResponseActions.upsertFormFixedResponses,
    (state, action) => adapter.upsertMany(action.formFixedResponses, state)
  ),
  on(FormFixedResponseActions.updateFormFixedResponse,
    (state, action) => adapter.updateOne(action.formFixedResponse, state)
  ),
  on(FormFixedResponseActions.updateFormFixedResponses,
    (state, action) => adapter.updateMany(action.formFixedResponses, state)
  ),
  on(FormFixedResponseActions.deleteFormFixedResponse,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FormFixedResponseActions.deleteFormFixedResponses,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FormFixedResponseActions.loadFormFixedResponses,
    (state, action) => adapter.setAll(action.formFixedResponses, state)
  ),
  on(FormFixedResponseActions.clearFormFixedResponses,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
